module.exports = __webpack_public_path__ + "img/collar edges length.cada9b4e.png";